module.exports = __webpack_public_path__ + "media/images/map/5-d6ce5fe7e2d14fcb09ad4e7f96697b6d.png";